import { Link } from "react-router-dom";

const WHY_POINTS = [
  { icon: "ri-wallet-3-line", title: "Earn Passive Rental Income", desc: "A steady stream of rental earnings from professionally managed bookings." },
  { icon: "ri-building-2-line", title: "Professional Resort Management", desc: "Your villa is maintained, marketed and rented by an expert hospitality team." },
  { icon: "ri-home-heart-line", title: "Personal Usage & Holiday Stays", desc: "Enjoy your own retreat whenever you like — it is still your holiday home." },
  { icon: "ri-line-chart-line", title: "Asset Appreciation Potential", desc: "Prime tourism land and premium builds grow in value over the long term." },
  { icon: "ri-earth-line", title: "Prime Tourism Destination", desc: "A scenic getaway location drawing year-round visitors and events." },
  { icon: "ri-stack-line", title: "Multiple Revenue Streams", desc: "Accommodation, weddings, corporate retreats, dining and wellness combined." },
  { icon: "ri-shield-check-line", title: "Hassle-Free Ownership", desc: "We handle operations, maintenance and bookings so you simply collect returns." },
  { icon: "ri-exchange-funds-line", title: "Flexible Exit Options", desc: "Liquidity-friendly paths to sell or exit your investment when the time is right." },
];

export default function WhyInvest() {
  return (
    <section id="why-invest" className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-14 items-center">
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Interior%20of%20a%20luxury%20A-frame%20wooden%20cabin%20with%20tall%20glass%20triangular%20window%2C%20warm%20cozy%20living%20room%20with%20leather%20sofa%2C%20stone%20fireplace%20and%20soft%20morning%20light%20through%20the%20forest%2C%20elegant%20rustic%20modern%20decor%2C%20warm%20green%20and%20amber%20tones%2C%20premium%20hospitality%20photography&width=1200&height=1400&seq=why-invest-nomad-1&orientation=portrait"
              alt="Luxury A-frame villa interior with fireplace and forest views"
              className="w-full h-full object-cover object-top rounded-3xl"
            />
            <div className="absolute -bottom-5 left-5 md:left-8 rounded-2xl bg-primary-700 text-background-50 px-5 py-4 shadow-none">
              <p className="font-heading text-2xl md:text-3xl font-semibold text-accent-400">₹12–30 Lakhs</p>
              <p className="text-xs text-background-100 mt-0.5">Annual revenue potential</p>
            </div>
          </div>

          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-leaf-line"></i> Why Invest
            </span>
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mt-4 leading-tight">
              A Lifestyle Asset That <span className="italic text-primary-700">Works for You</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
              Invest in a premium villa that combines the joy of ownership with the power of a
              professionally managed income-generating asset.
            </p>

            <Link
              to="/why-invest"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-primary-600 text-primary-700 px-5 py-2.5 hover:bg-primary-600 hover:text-background-50 transition-colors"
            >
              Learn Why Land is a Smart Asset
              <i className="ri-arrow-right-line"></i>
            </Link>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8 md:mt-10">
              {WHY_POINTS.map((point) => (
                <div key={point.title} className="flex items-start gap-3.5 rounded-xl bg-background-50 border border-background-200 p-4">
                  <span className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-100 text-primary-700 shrink-0">
                    <i className={`${point.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-950 leading-snug">{point.title}</h4>
                    <p className="text-xs text-foreground-600 mt-1 leading-relaxed">{point.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}